var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages"},_vm._l((_vm.allMessages),function(ref,id){
var type = ref.type;
var text = ref.text;
return _c('Message',{key:id,attrs:{"type":type,"text":text}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }